import { Button, FlexBox, Icon, Link, Typography } from '@vp/swan';
import { __ } from '@99designs/i18n';
import { sendNavigationEvent, usePage } from '@99designs/tracking';
import { useIbpoBriefCreateURL } from '../../../lib/useIbpoBriefCreateURL';

export const CreateAProjectCTA = () => {
    const { pageData } = usePage();
    const briefCreateURL = useIbpoBriefCreateURL();
    const pageZone = 'Design Category Tiles';
    const ctaValue = 'CreateAProject-CTA';
    const onClickTracking = () => {
        sendNavigationEvent({
            label: `Content: ${pageZone}`,
            eventDetail: `${
                pageData.pagePath || window.location.pathname
            };${briefCreateURL};${pageZone};${ctaValue}`,
            navigationDetail: ctaValue,
            ...pageData,
        });
    };
    return (
        <FlexBox
            alignItems="center"
            gap="5"
            flexDirection={{ xs: 'column', sm: 'row' }}
            data-testid="create-project-cta"
        >
            <Typography data-testid="create-project-cta-copy">
                {__('Can’t find the design service you are looking for?', {
                    _context:
                        'message displayed next to "Create a project" button that prompts users who can’t find the design service they are looking for to create a new project',
                })}
            </Typography>
            <Button
                skin="secondary"
                render={(props) => (
                    <Link
                        to={briefCreateURL}
                        className={props.className}
                        onClick={onClickTracking}
                        data-testid="create-project-cta-link"
                    >
                        {props.children}
                    </Link>
                )}
            >
                {__('Create a project', {
                    _context: 'button that prompts users to create a new project',
                })}
                <Icon iconType="arrowRight" />
            </Button>
        </FlexBox>
    );
};
